import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessAnomalyAlertsSlice } from './get';

import {
	coreDataSecurityAccessAnomalyAlertsExportReducers,
	coreDataSecurityAccessAnomalyAlertsExportWatchers
} from './export';

export const coreDataSecurityAccessAnomalyAlertsReducers = combineReducers({
	export: coreDataSecurityAccessAnomalyAlertsExportReducers,
	get: getCoreDataSecurityAccessAnomalyAlertsSlice.asyncReducers
});

export const coreDataSecurityAccessAnomalyAlertsWatchers = combineAllWatchers([
	coreDataSecurityAccessAnomalyAlertsExportWatchers,
	getCoreDataSecurityAccessAnomalyAlertsSlice.asyncWatchers
]);
